import { render, staticRenderFns } from "./AffiliatesAccordionToTab.vue?vue&type=template&id=e1ae5d76&scoped=true"
import script from "./AffiliatesAccordionToTab.js?vue&type=script&lang=js&external"
export * from "./AffiliatesAccordionToTab.js?vue&type=script&lang=js&external"
import style0 from "./AffiliatesAccordionToTab.scss?vue&type=style&index=0&id=e1ae5d76&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ae5d76",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default})
